import {json} from './json.mapper';

export class ListResponseRecord {
    @json()
    count: number;
    @json()
    sortMeta: string[];
    @json()
    filterMeta: string[];
}
